import { connectIncludedData } from './utils';
import {
  CANDIDATE_CREATE_REQUEST,
  CANDIDATE_CREATE_FAIL,
  CANDIDATE_CREATE_SUCCESS,
  CANDIDATE_CREATE_RESET,
  PATIENT_SECOND_OPINION_CREATE_REQUEST,
  PATIENT_SECOND_OPINION_BOOKING_REQUEST,
  PATIENT_SECOND_OPINION_UPDATE_REQUEST,
  BOOKING_CREATE_SUCCESS,
  BOOKING_UPDATE_SUCCESS,
  MODAL_CANDIDATE_CREATE_SUCCESS,
  BOOKING_UPDATE_REQUESTED
} from './constants';

export const initialState = {
  created: false,
  modalCreated: false,
  sending: false,
  error: undefined,
  created_patient_id: undefined,
  doctors: [],
  booking_id: undefined
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case CANDIDATE_CREATE_REQUEST: {
      return {
        ...state,
        sending: true,
        error: undefined
      };
    }

    case PATIENT_SECOND_OPINION_CREATE_REQUEST: {
      return {
        ...state,
        sending: true,
        error: undefined
      };
    }

    case PATIENT_SECOND_OPINION_UPDATE_REQUEST: {
      return {
        ...state,
        sending: true,
        error: undefined
      };
    }

    case PATIENT_SECOND_OPINION_BOOKING_REQUEST:
      return { ...state, sending: true, slug: action.slug };

    case CANDIDATE_CREATE_FAIL: {
      return {
        ...state,
        sending: false,
        error: { email: ['is already registered with yapita health'] }
      };
    }

    case CANDIDATE_CREATE_SUCCESS: {
      return {
        ...state,
        sending: false,
        error: undefined,
        created: true,
        created_patient_id: action.data.data.patient_id
      };
    }

    case BOOKING_CREATE_SUCCESS: {
      return {
        ...state,
        sending: false,
        error: undefined,
        created: true,
        created_patient_id: action.data.data.data.attributes.patient_id,
        booking_id: action.data.data.data.id
      };
    }

    case BOOKING_UPDATE_REQUESTED: {
      return {
        ...state,
        sending: false,
        error: undefined,
        created: true,
        created_patient_id: action.data.data.data.attributes.patient_id,
        booking_id: action.data.data.data.id,
        loadedTreatments: action.data.data.data.attributes.treatments,
        loadedPreferredCountry: action.data.data.data.attributes.preferred_country,
        loadedDepartment: action.data.data.data.attributes.department,
        doctors: action.data.data.included.filter(doc => doc.type === 'matching_doctor')
          .map(doc => connectIncludedData(doc, action.data.data.included || [])),
      };
    }

    case BOOKING_UPDATE_SUCCESS: {
      return {
        ...state,
        sending: false,
        error: undefined,
        created: true,
        created_patient_id: action.data.data.data.attributes.patient_id,
        doctors: action.data.data.included.filter(doc => doc.type === 'matching_doctor')
          .map(doc => connectIncludedData(doc, action.data.data.included || [])),
        booking_id: action.data.data.data.id
      };
    }

    case MODAL_CANDIDATE_CREATE_SUCCESS: {
      return {
        ...state,
        sending: false,
        error: undefined,
        modalCreated: true,
        created_patient_id: action.data.data.patient_id
      };
    }

    case CANDIDATE_CREATE_RESET: {
      if (action.isModal) {
        return {
          ...state,
          modalCreated: false,
          error: undefined,
          sending: false
        };
      }
      return {
        ...initialState
      };
    }

    default:
      return state;
  }
};

export default reducer;
